// Single canonical logo: blue triangle + dark ZEBLAN wordmark (transparent PNG)
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-agents-build-3/artifacts/l93aqmot_Teal.png";

// Kept as alias in case any older import remains
export const LOGOS = {
  positive: LOGO_URL,
  negative: LOGO_URL,
  teal: LOGO_URL,
};
